import { CSSProperties } from 'react';

/** English copy matches AccountX / IFCA e-Invoice. */
export const MFA_COPY = {
	sectionTitle: 'Multi-Factor Authentication',
	enrolTitle: 'Multi-Factor Authentication Setup',
	enrolBody1:
		'This account is secured using multi-factor authentication (MFA).',
	enrolBody2:
		'Please scan the following QR Code using your authentication app (Google or Microsoft Authenticator) to retrieve your one-time password (OTP) code.',
	verifyTitle: 'Multi-Factor Authentication',
	verifyBody:
		'Please enter the one-time password (OTP) code from your authentication app (Google or Microsoft Authenticator) to proceed.',
	resetBreadcrumb: 'Reset Multi-Factor Authenticator',
	resetAction: 'Reset MFA',
	scanBody:
		'Please scan the following QR Code using your authentication app (Google or Microsoft Authenticator) to retrieve your one-time password (OTP) code.',
	resetRemovesPrevious:
		'This will remove the previous authentication app token.',
	otpLabel: 'OTP Code *',
	verifyButton: 'Verify',
	anotherAccount: 'Login with another account',
	removeAction: 'Remove Multi-Factor Authenticator',
};

export const mfaWrapStyle: CSSProperties = {
	fontSize: '12px',
	lineHeight: 1.5,
	whiteSpace: 'normal',
	overflow: 'visible',
	textOverflow: 'clip',
	wordBreak: 'break-word',
};
